(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('supplier-coupon', {
                parent: 'entity',
                url: '/supplier-coupon?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.supplierCoupon.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/supplier-coupon/supplier-coupons.html',
                        controller: 'SupplierCouponController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierCoupon');
                        $translatePartialLoader.addPart('couponStatus');
                        $translatePartialLoader.addPart('activityType');
                        $translatePartialLoader.addPart('amountTypes');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplier-coupon-detail', {
                parent: 'entity',
                url: '/supplier-coupon/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.supplierCoupon.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/supplier-coupon/supplier-coupon-detail.html',
                        controller: 'SupplierCouponDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierCoupon');
                        $translatePartialLoader.addPart('couponStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'supplierCoupon', function ($stateParams, SupplierCoupon) {
                        return SupplierCoupon.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('supplier-coupon.new', {
                parent: 'supplier-coupon',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/supplier-coupon/supplier-coupon-dialog.html',
                        controller: 'SupplierCouponDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    description: null,
                                    durationDays: null,
                                    chargeFee: null,
                                    startDate: null,
                                    endDate: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('supplier-coupon', null, {reload: true});
                    }, function () {
                        $state.go('supplier-coupon');
                    });
                }]
            })
            .state('supplier-coupon.edit', {
                parent: 'supplier-coupon',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/supplier-coupon/supplier-coupon-dialog.html',
                        controller: 'SupplierCouponDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['SupplierCoupon', function (SupplierCoupon) {
                                return SupplierCoupon.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplier-coupon', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplier-coupon.delete', {
                parent: 'supplier-coupon',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/supplier-coupon/supplier-coupon-delete-dialog.html',
                        controller: 'SupplierCouponDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['SupplierCoupon', function (SupplierCoupon) {
                                return SupplierCoupon.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplier-coupon', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
